import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: "Please describe how you've been taking your medication",
    field: 'hrt1MonthFollowup_pleaseDescribeHowYouVeBeenTakingYourMedication',
    type: 'info',
    answer: {
      type: 'text',
      name: 'pleaseDescribeHowYouVeBeenTakingYourMedicationDesc',
      placeholder: ''
    }
  },

  {
    label: 'Do you forget to take your medication',
    field: 'hrt1MonthFollowup_doYouForgetToTakeYourMedication',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Never',
          key: 'never'
        },
        {
          value: 'Sometimes',
          key: 'sometimes'
        },
        {
          value: 'More often than not',
          key: 'moreOftenThanNot'
        }
      ]
    }
  },

  {
    label: 'Are you having hot flashes',
    field: 'hrt1MonthFollowup_areYouHavingHotFlashes',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'hot flashes the same as before',
          key: 'hotFlashesTheSameAsBefore'
        },
        {
          value: 'hot flashes slightly improved from before',
          key: 'hotFlashesSlightlyImprovedFromBefore'
        },
        {
          value: 'hot flashes greatly improved',
          key: 'hotFlashesGreatlyImproved'
        },
        {
          value: 'hot flashes resolved',
          key: 'hotFlashesResolved'
        },
        {
          value: 'I never had hot flashes',
          key: 'iNeverHadHotFlashes'
        },
        {
          value: "I have new hot flashes but didn't before",
          key: 'iHaveNewHotFlashesButDidNotBefore'
        }
      ]
    }
  },

  {
    label: 'Are you experiencing any vaginal symptoms',
    field: 'hrt1MonthFollowup_areYouExperiencingAnyVaginalSymptoms',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'dryness the same as before',
          key: 'drynessTheSameAsBefore'
        },
        {
          value: 'irritation the same as before',
          key: 'irritationTheSameAsBefore'
        },
        {
          value: 'itching the same as before',
          key: 'itchingTheSameAsBefore'
        },
        {
          value: 'burning the same as before',
          key: 'burningTheSameAsBefore'
        },
        {
          value: 'symptoms have resolved',
          key: 'symptomsHaveResolved'
        },
        {
          value:
            "I have new dryness, irritation, itching and burning but didn't before",
          key: 'iHaveNewDrynessIrritationItchingAndBurningButDidNotBefore'
        },
        {
          value: 'None of the above',
          key: 'noneOfTheAbove'
        }
      ]
    }
  },

  {
    label: 'How is your mood?',
    field: 'hrt1MonthFollowup_howIsYourMood',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I feel stable',
          key: 'iFeelStable'
        },
        {
          value: 'Sometimes I feel like my mood is changing',
          key: 'sometimesIFeelLikeMyMoodIsChanging'
        },
        {
          value: 'My mood is constantly changing',
          key: 'myMoodIsConstantlyChanging'
        }
      ]
    }
  },

  {
    label: 'How is your sleep',
    field: 'hrt1MonthFollowup_howIsYourSleep',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Could be better',
          key: 'couldBeBetter'
        },
        {
          value: 'No changes',
          key: 'noChanges'
        },
        {
          value: 'Significantly worsened',
          key: 'significantlyWorsened'
        }
      ]
    }
  },

  {
    label: 'are you experiencing the following symptoms',
    field: 'hrt1MonthFollowup_hrtPeriodChanges',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'breastTenderness', value: 'breast tenderness' },
        { key: 'bloating', value: 'bloating' },
        { key: 'drowsiness', value: 'drowsiness' },
        {
          key: 'noPeriodChanges',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },

  {
    label: 'Have you started any new medications?',
    field: 'hrt1MonthFollowup_haveYouStartedAnyNewMedications',
    type: 'info',
    answer: {
      type: 'text',
      name: 'haveYouStartedAnyNewMedicationsDesc',
      placeholder: ''
    }
  },

  {
    label: 'Are there any other symptoms you are experiencing',
    field: 'hrt1MonthFollowup_areThereAnyOtherSymptomsYouAreExperiencing',
    type: 'info',
    answer: {
      type: 'text',
      name: 'areThereAnyOtherSymptomsYouAreExperiencingDesc',
      placeholder: ''
    }
  }
];

export default questionsModels;
